var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7073 1.45446C11.8386 0.516515 10.6252 0 9.28592 0C7.93949 0 6.72209 0.51339 5.85736 1.44553C4.98326 2.38793 4.55737 3.66873 4.65737 5.05176C4.85558 7.78031 6.93191 9.99994 9.28592 9.99994C11.6399 9.99994 13.7127 7.78076 13.914 5.05265C14.0154 3.68212 13.5868 2.404 12.7073 1.45446ZM17.143 19.9999H1.42882C1.22313 20.0026 1.01944 19.9593 0.832556 19.8734C0.645672 19.7874 0.480298 19.6609 0.348468 19.503C0.0582907 19.1561 -0.0586729 18.6825 0.0279337 18.2035C0.404717 16.1133 1.5806 14.3575 3.42881 13.1249C5.07076 12.0307 7.15066 11.4285 9.28592 11.4285C11.4212 11.4285 13.5011 12.0312 15.143 13.1249C16.9912 14.3571 18.1671 16.1129 18.5439 18.203C18.6305 18.682 18.5135 19.1557 18.2234 19.5026C18.0916 19.6606 17.9262 19.7872 17.7393 19.8732C17.5524 19.9592 17.3487 20.0025 17.143 19.9999Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalIcon);
export default __webpack_public_path__ + "static/media/portalIcon.7250357be5d22dfadb3abfdaa98478fc.svg";
export { ForwardRef as ReactComponent };